// REMIX HMR BEGIN
if (!window.$RefreshReg$ || !window.$RefreshSig$ || !window.$RefreshRuntime$) {
  console.warn('remix:hmr: React Fast Refresh only works when the Remix compiler is running in development mode.');
} else {
  var prevRefreshReg = window.$RefreshReg$;
  var prevRefreshSig = window.$RefreshSig$;
  window.$RefreshReg$ = (type, id) => {
    window.$RefreshRuntime$.register(type, "\"app/components/header/NavMenu.tsx\"" + id);
  }
  window.$RefreshSig$ = window.$RefreshRuntime$.createSignatureFunctionForTransform;
}
var _s = $RefreshSig$();
import * as __hmr__ from "remix:hmr";
if (import.meta) {
  import.meta.hot = __hmr__.createHotContext(
  //@ts-expect-error
  "app/components/header/NavMenu.tsx");
  import.meta.hot.lastModified = "1726055288424.296";
}
// REMIX HMR END

import * as NavigationMenu from '@radix-ui/react-navigation-menu';
import classNames from 'classnames';
import CaretDownIconSVG from '~/resources/svgs/CaretDownIconSVG';
import { NavLink, useLocation, useParams } from '@remix-run/react';
import ThemeIconSVG from '~/resources/svgs/ThemeIconSVG';
import { Theme, useTheme } from '~/utils/provider/theme-provider';
import SYS_CONFIG from '~/config';
import { createLangPathByParam, langSwitcher } from '~/utils/lang';
import LanguageIconSVG from '~/resources/svgs/LanguageIconSVG';
import { useLang } from '~/utils/provider/lang-provider';
export default function MainNavigationMenu() {
  _s();
  const [, setTheme] = useTheme();
  const {
    lang
  } = useParams();
  const {
    pathname
  } = useLocation();
  const l_labels = useLang('labels');
  const {
    ROUTE_FRAGMENTS: {
      RF_GUIDE,
      RF_KANTONSRAT
    }
  } = SYS_CONFIG;
  return <NavigationMenu.Root className="NavigationMenuRoot">

            <NavigationMenu.List className="NavigationMenuList">



                <NavigationMenu.Item>
                    <NavigationMenu.Trigger className="NavigationMenuTrigger">
                        Menu <CaretDownIconSVG width={20} height={20} className="CaretDown" aria-hidden />
                    </NavigationMenu.Trigger>
                    <NavigationMenu.Content className="NavigationMenuContent">
                        <ul className="List one">
                            <li style={{
              gridRow: 'span 3'
            }}>
                                <NavigationMenu.Link asChild>
                                    <NavLink className="Callout" to={createLangPathByParam(lang, '/')}>
                                       <div className='logo'>ZH</div>
                                        <div className="CalloutHeading">{l_labels('nav_home')}</div>
                                        <p className="CalloutText">{l_labels('nav_home_desc')}</p>
                                    </NavLink>
                                </NavigationMenu.Link>
                            </li>

                           

                            <li>
                                <NavigationMenu.Link asChild>
                                    <NavLink className={classNames('ListItemLink')} to={createLangPathByParam(lang, `/${RF_GUIDE}`)}>
                                        <div className="ListItemHeading">{l_labels('nav_explore')}</div>
                                        <p className="ListItemText">{l_labels('nav_explore_desc')}</p>
                                    </NavLink>
                                </NavigationMenu.Link>
                            </li>
                            <li>
                                <NavigationMenu.Link asChild>
                                    <NavLink className={classNames('ListItemLink')} to={createLangPathByParam(lang, `/${RF_KANTONSRAT}`)}>
                                        <div className="ListItemHeading">{l_labels('nav_kantonsrat')}</div>
                                        <p className="ListItemText">{l_labels('nav_kantonsrat_desc')}</p>
                                    </NavLink>
                                </NavigationMenu.Link>
                            </li>
                            <li>
                                <NavigationMenu.Link asChild>
                                    <NavLink className={classNames('ListItemLink')} to={createLangPathByParam(lang, `/about`)}>
                                        <div className="ListItemHeading">{l_labels('nav_about')}</div>
                                        <p className="ListItemText">{l_labels('nav_about_desc')}</p>
                                    </NavLink>
                                </NavigationMenu.Link>
                            </li>

                           
                        </ul>
                    </NavigationMenu.Content>
                </NavigationMenu.Item>

                <NavigationMenu.Item>
                    <NavigationMenu.Trigger className="NavigationMenuTrigger">
                        <LanguageIconSVG aria-label="language" /> <CaretDownIconSVG width={20} height={20} className="CaretDown" aria-hidden />
                    </NavigationMenu.Trigger>
                    <NavigationMenu.Content className="NavigationMenuContent">
                        <ul className="List two">
                            {SYS_CONFIG.SUPPORTED_LANG_OBJECTS.map(it => <li key={it.lang_code}>
                                    <NavigationMenu.Link asChild>
                                        <NavLink className="hdr_nav_a" to={langSwitcher(lang, pathname, it.lang_code)}>{it.label}</NavLink>
                                    </NavigationMenu.Link>
                                </li>)}
                        </ul>
                    </NavigationMenu.Content>
                </NavigationMenu.Item>

                <NavigationMenu.Item>
                    <button className="NavigationMenuTrigger" type="button" onClick={() => setTheme(prev => prev === Theme.LIGHT ? Theme.DARK : Theme.LIGHT)}>
                        <ThemeIconSVG aria-label="theme" />
                    </button>
                </NavigationMenu.Item>

                <NavigationMenu.Indicator className="NavigationMenuIndicator">
                    <div className="Arrow" />
                </NavigationMenu.Indicator>
            </NavigationMenu.List>

            <div className="ViewportPosition">
                <NavigationMenu.Viewport className="NavigationMenuViewport" />
            </div>
        </NavigationMenu.Root>;
}
_s(MainNavigationMenu, "cO40GWdH707V1TIx5Cq+rkH3GHA=", false, function () {
  return [useTheme, useParams, useLocation, useLang];
});
_c = MainNavigationMenu;
var _c;
$RefreshReg$(_c, "MainNavigationMenu");

window.$RefreshReg$ = prevRefreshReg;
window.$RefreshSig$ = prevRefreshSig;